import React, { useEffect, useState, Fragment, useRef } from "react";
import {
    View, Text, StyleSheet,
} from "react-native";

import { useNavigate } from 'react-router-dom';
import { FONT, SESSIONSTORAGE } from "../../../value/staticValues";
import { PAGE_URL } from "../../../value/Url";

//import { ReactComponent as BiImg } from "../../../img/ico-etri-rep-cloud-bi.svg";
import { ReactComponent as BiImg } from "../../../img/ico-fornax-bi-gradient.svg";


import { ReactComponent as MenuTotalViewImg } from '../../../img/btn-side-bar-menu-total-view-normal.svg';
import { ReactComponent as LanguageIcoImg } from '../../../img/ico-lang.svg';
import { ReactComponent as AlertImg } from '../../../img/ico-alert-normal.svg';
import { ReactComponent as UserProfileImg } from '../../../img/ico-user-info-profile-thumb.svg';
import { ReactComponent as UserProfileCollapsedImg } from '../../../img/btn-header-collapsed.svg';
import { ReactComponent as MenuTotalCloseImg } from '../../../img/btn-side-bar-menu-total-view-closed.svg';
import { ReactComponent as MenuTotalHoverImg } from '../../../img/btn-side-bar-menu-total-view-hover.svg';
import { ReactComponent as BtnHeaderNextImg } from '../../../img/btn-header-next.svg';

import { base64Decoding } from "../../../common/util";
import { useTranslation } from "react-i18next";

import HeaderUserProfile from "./HeaderUserProfile";
import SiteMap from "./SiteMap";

interface HeaderBarProps {
    setLoading: Function,
}

export default function MainHeaderBar(props:HeaderBarProps) {
    const { t } = useTranslation();
    const profileLayout = useRef<any>();
    const sitemapLayout = useRef<any>();
    const loggedInUserEmail = base64Decoding(sessionStorage.getItem(SESSIONSTORAGE.USER_EMAIL) || '');

    const navigate = useNavigate();
    const menuTotalViewImgComponentNormal = <MenuTotalViewImg  style={className.menuTotalViewImg} onMouseOut={() => setMenuTotalViewImgMouseOverYn(false)} onMouseOver={() => setMenuTotalViewImgMouseOverYn(true)} onClick={toggleMenuCollapsed}/>;
    const menuTotalViewImgComponentClose = <MenuTotalCloseImg  style={className.menuTotalViewImg} onMouseOut={() => setMenuTotalViewImgMouseOverYn(false)} onMouseOver={() => setMenuTotalViewImgMouseOverYn(true)} onClick={toggleMenuCollapsed}/>;
    const menuTotalViewImgComponentHover = <MenuTotalHoverImg  style={className.menuTotalViewImg} onMouseOut={() => setMenuTotalViewImgMouseOverYn(false)} onMouseOver={() => setMenuTotalViewImgMouseOverYn(true)} onClick={toggleMenuCollapsed}/>;

    const [userProfileShowYn, setUserProfileShowYn] = useState(false);
    const [menuExpandShowYn, setMenuExpandShowYn] = useState(false);
    const [menuTotalViewImgMouseOverYn, setMenuTotalViewImgMouseOverYn] = useState(false);
    const [menuTotalViewImg, setMenuTotalViewImg] = useState(menuTotalViewImgComponentNormal);

    const [location, setLocation] = useState("")

    useEffect(()=>{
        const pathname = window.location.pathname;
        switch(pathname) {
            // 가상화 자원 그룹 관리
            case PAGE_URL.DASHBOARD:
                setLocation("Dashboard")
                break;

            // 가상화 자원 그룹 관리
            case PAGE_URL.VIRTUAL_RESOURCE_GROUP_REGION:
                setLocation("가상화 자원 그룹 관리|리전 관리")
                break;
            case PAGE_URL.VIRTUAL_RESOURCE_GROUP_HOST_CLUSTER:
                setLocation("가상화 자원 그룹 관리|호스트 클러스터 관리")
                break;
            case PAGE_URL.VIRTUAL_RESOURCE_GROUP_AZ:
                setLocation("가상화 자원 그룹 관리|AZ 관리")
                break;

            // 가상화 플랫폼 물리 자원 관리
            case PAGE_URL.VIRTUAL_PHYSICAL_RESOURCE_HOST:
                setLocation("가상화 플랫폼 물리 자원 관리|호스트 관리")
                break;
            case PAGE_URL.VIRTUAL_PHYSICAL_RESOURCE_STORAGE:
                setLocation("가상화 플랫폼 물리 자원 관리|스토리지 관리")
                break;
            case PAGE_URL.VIRTUAL_PHYSICAL_RESOURCE_NETWORK:
                setLocation("가상화 플랫폼 물리 자원 관리|네트워크 관리")
                break;

            // 응용 관리
            case PAGE_URL.APPLICATION_MY_INFO:
                setLocation("응용 관리|내정보")
                break;
            case PAGE_URL.APPLICATION_ACCOUNT:
                setLocation("응용 관리|계정 관리")
                break;
            case PAGE_URL.APPLICATION_PASSWORD:
                setLocation("응용 관리|계정 정보(Self) > 비밀번호 변경")
                break;
            case PAGE_URL.APPLICATION_DOMAIN:
                setLocation("응용 관리|도메인 관리")
                break;
            case PAGE_URL.APPLICATION_PROJECT:
                setLocation("응용 관리|프로젝트 관리")
                break;

            // 가상화 플랫폼 논리 자원 관리
            case PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_IMAGE:
                setLocation("가상화 플랫폼 논리 자원 관리|가상머신 이미지 관리")
                break;
            case PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_PERFORMANCE:
                setLocation("가상화 플랫폼 논리 자원 관리|가상머신 사양 관리")
                break;
            case PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_NETWORK:
                setLocation("가상화 플랫폼 논리 자원 관리|가상머신 네트워크 관리")
                break;
            case PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_NETWORK_TOPOLOGY:
                setLocation("가상화 플랫폼 논리 자원 관리|가상머신 네트워크 토폴로지")
                break;
            case PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_SECURITY:
                setLocation("가상화 플랫폼 논리 자원 관리|서브넷 관리")
                break;
            case PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_SECURITY_RULE:
                setLocation("가상화 플랫폼 논리 자원 관리|가상머신 보안 그룹 관리")
                break;
            case PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_IP:
                setLocation("가상화 플랫폼 논리 자원 관리|유동IP 관리")
                break;
            case PAGE_URL.VIRTUAL_LOGICAL_RESOURCE_KEY_PAIR:
                setLocation("가상화 플랫폼 논리 자원 관리|키페어 관리")
                break;

            // 가상화 플랫폼 가상 인스턴스 관리
            case PAGE_URL.VIRTUAL_INSTANCE_MGMT_VM:
                setLocation("가상화 플랫폼 가상 인스턴스 관리|가상머신 관리")
                break;
            case PAGE_URL.VIRTUAL_INSTANCE_MGMT_VM_BACKUP_IMAGE:
                setLocation("가상화 플랫폼 가상 인스턴스 관리|가상머신 백업 이미지 관리")
                break;
            case PAGE_URL.VIRTUAL_INSTANCE_MGMT_VOLUMNE:
                setLocation("가상화 플랫폼 가상 인스턴스 관리|가상머신 볼륨 관리")
                break;

            // 컨테이너 플랫폼 논리 리소스 관리
            case PAGE_URL.CONTAINER_LOGICAL_RESOURCE_NODE:
                setLocation("컨테이너 플랫폼 논리 리소스 관리|컨테이너 노드 관리")
                break;
            case PAGE_URL.CONTAINER_LOGICAL_RESOURCE_CLUSTER:
                setLocation("컨테이너 플랫폼 논리 리소스 관리|컨테이너 클러스터 템플릿 관리")
                break;
            case PAGE_URL.CONTAINER_LOGICAL_RESOURCE_NAMESPACE:
                setLocation("컨테이너 플랫폼 논리 리소스 관리|컨테이너 클러스터 관리")
                break;
            case PAGE_URL.CONTAINER_LOGICAL_RESOURCE_CLUSTER_TEMPLATE:
                setLocation("컨테이너 플랫폼 논리 리소스 관리|컨테이너 네임스페이스 관리")
                break;
            case PAGE_URL.CONTAINER_LOGICAL_RESOURCE_REGISTRY:
                setLocation("컨테이너 플랫폼 논리 리소스 관리|컨테이너 이미지 저장소 관리")
                break;

            // 컨테이너 플랫폼 클러스터 관리
            case PAGE_URL.CONTAINER_CLUSTER_MGMT_NAMESPACE:
                setLocation("컨테이너 플랫폼 클러스터 관리|컨테이너 네임스페이스 관리")
                break;
            case PAGE_URL.CONTAINER_CLUSTER_MGMT_IMAGE:
                setLocation("컨테이너 플랫폼 클러스터 관리|컨테이너 이미지 관리")
                break;
            case PAGE_URL.CONTAINER_CLUSTER_MGMT_POD_PROFILE:
                setLocation("컨테이너 플랫폼 클러스터 관리|컨테이너 파드 프로파일 관리")
                break;
            case PAGE_URL.CONTAINER_CLUSTER_MGMT_APPLICATION_POD:
                setLocation("컨테이너 플랫폼 클러스터 관리|컨테이너 파드 배포 관리")
                break;
            case PAGE_URL.CONTAINER_CLUSTER_MGMT_APPLICATION_DEPLOYMENT:
                setLocation("컨테이너 플랫폼 클러스터 관리|컨테이너 파드 관리")
                break;
            case PAGE_URL.CONTAINER_CLUSTER_MGMT_POD_VOLUME:
                setLocation("컨테이너 플랫폼 클러스터 관리|컨테이너 볼륨 관리")
                break;
            case PAGE_URL.CONTAINER_CLUSTER_MGMT_SERVICE:
                setLocation("컨테이너 플랫폼 클러스터 관리|컨테이너 서비스 관리")
                break;
            case PAGE_URL.CONTAINER_CLUSTER_MGMT_INGRESS:
                setLocation("컨테이너 플랫폼 클러스터 관리|컨테이너 인그레스 관리")
                break;

            // 컨테이너 플랫폼 가상 인스턴스 사용
            case PAGE_URL.VIRTUAL_INSTANCE_USEAGE_VM:
                setLocation("컨테이너 플랫폼 가상 인스턴스 사용|가상머신 사용")
                break;
            case PAGE_URL.VIRTUAL_INSTANCE_USEAGE_VM_DISK:
                setLocation("컨테이너 플랫폼 가상 인스턴스 사용|가상머신 디스크 사용")
                break;
            case PAGE_URL.VIRTUAL_INSTANCE_USEAGE_VM_VOLUME:
                setLocation("컨테이너 플랫폼 가상 인스턴스 사용|가상머신 볼륨 사용")
                break;


            // RDS 제품
            case PAGE_URL.SERVICE_PRODUCT:
                setLocation("서비스 제품 관리")
                break;
            case PAGE_URL.SERVICE_LICENSE:
                setLocation("서비스 라이센스 관리")
                break;
            case PAGE_URL.SERVICE_PURCHASE:
                setLocation("서비스 구매 관리")
                break;
            case PAGE_URL.SERVICE_RDS_CLIENT_PACKAGE:
                setLocation("서비스 RDS 클라이언트 패키지 관리")
                break;
            case PAGE_URL.SERVICE_RDS_DEVICE:
                setLocation("RDS 서비스 장치 관리")
                break;
        }
    },[window.location.pathname])

    useEffect(() => {
        if(userProfileShowYn) {
            return;
        }
        if(menuTotalViewImgMouseOverYn) {
            setMenuTotalViewImg(menuTotalViewImgComponentHover);
        } else {
            setMenuTotalViewImg(menuTotalViewImgComponentNormal);
        }
    }, [menuTotalViewImgMouseOverYn]);

    useEffect(() => {
        if(menuExpandShowYn) {
            setMenuTotalViewImg(menuTotalViewImgComponentClose);
        } else {
            if(menuTotalViewImgMouseOverYn) {
                setMenuTotalViewImg(menuTotalViewImgComponentHover);
            } else {
                setMenuTotalViewImg(menuTotalViewImgComponentNormal);
            }

        }
    }, [menuExpandShowYn]);


    function toggleUserProfileCollapsed() {
        if(!userProfileShowYn) {
            setMenuExpandShowYn(false);
        }
        setUserProfileShowYn(!userProfileShowYn);
    }

    document.addEventListener("mouseup", (event) => {
        if (userProfileShowYn && profileLayout && profileLayout.current && !profileLayout.current.contains(event.target)) {
            setUserProfileShowYn(false);
        }
        if (sitemapLayout && sitemapLayout.current && !sitemapLayout.current.contains(event.target)) {
            setMenuExpandShowYn(false);
        }
    });

    function clickHomeButton() {
        navigate(`${PAGE_URL.DASHBOARD}`);
    }

    // Hamberger 버튼 클릭
    function toggleMenuCollapsed() {
        if(!menuExpandShowYn) {
            setUserProfileShowYn(false);
        }
        setMenuExpandShowYn(!menuExpandShowYn);
    }

    // Hamberger 클릭 후 보이는 메뉴 선택
    function clickMenuLink(link:string) {
        setMenuExpandShowYn(false);
        navigate(link);
    }

    function detectClictEvent(event, element) {
        // if(!element.current || !element.current.contains(event.target)) {
        //     if(userProfileShowYn) {
        //         setUserProfileShowYn(false);
        //     }
        //     if(menuExpandShowYn) {
        //         setMenuExpandShowYn(false);
        //     }
        // }
    }


    return (
        <View style={{ flex:1, height: 64, zIndex: 10, marginBottom: 0 }}>
            <div style={{
                height: 64,
                padding: "0 20px 0 0",
                backgroundColor: "#fff",
                boxShadow: "0 0 6px 0 rgba(79, 95, 216, 0.3)",
                display: "flex", alignItems: "center"
            }}>
                {menuTotalViewImg}
                <BiImg style={{cursor: "pointer"}} onClick={clickHomeButton} />
                {/* <Text style={{
                    marginLeft: 15,
                    fontFamily: FONT.MEDIUM,
                    fontSize: 20,
                    color: "#333"
                }}>
                    {t("PAGE_TITLE")}
                </Text> */}

                {/*
                    //TODO: page 이름을 출력하기 위해 MainPage 부터 props 받는 로직 필요
                */}
                <View style={{ flex: 1, paddingLeft: "65px", flexDirection: "row", alignItems: "center"}}>
                    <BtnHeaderNextImg/>
                    <Text style={{
                        fontFamily: "NotoSansKR-Medium",
                        fontSize: 12,
                        fontWeight: "normal",
                        letterSpacing: 0.16,
                        color: "#8c8c8c"
                    }}>
                        {location.split("|")[0]}
                    </Text>
                    {location.split("|")[1] && <BtnHeaderNextImg/>}
                    {location.split("|")[1] && <Text style={{
                        fontFamily: "NotoSansKR-Medium",
                        fontSize: 12,
                        fontWeight: "normal",
                        letterSpacing: 0.16,
                        color: "#333333"
                    }}>
                        {location.split("|")[1]}
                    </Text>}
                </View>

                <LanguageIcoImg/>
                <Text style={{
                    fontFamily: "NotoSansKR-Medium",
                    fontSize: 12,
                    fontWeight: "500",
                    letterSpacing: 0.16,
                    color: "#848484"
                }}>
                    {t("LANGUAGE")}
                </Text>
                {
                // <Fragment>
                //     <AlertImg style={{ marginLeft: 20, cursor: "pointer" }}/>
                //     <div style={{
                //         minWidth: 15, height: 15,
                //         margin: "-13px 0 0 -12px",
                //         backgroundColor: "#db4d30",
                //         borderRadius: 25,
                //         display: "flex", alignItems: "center", justifyContent: "center",
                //         cursor: "pointer"
                //     }}>
                //         <Text style={{
                //             fontFamily: "NotoSansKR-Medium",
                //             fontSize: 7,
                //             fontWeight: "500",
                //             color: "#f7f7f7"
                //         }}>
                //             0
                //         </Text>
                //     </div>
                // </Fragment>
                }
                <div
                    style={{
                        minWidth: 206,
                        marginLeft: 25,
                        borderRadius: 18,
                        border: "solid 1px #e5e9ec",
                        backgroundColor: "#fff",
                        display: "flex", alignItems: "center",
                        cursor: "pointer"
                    }}
                    onClick={toggleUserProfileCollapsed}
                >
                    <UserProfileImg style={{ paddingLeft: 1 }} />
                    <Text style={{
                        minWidth: 132,
                        marginLeft: 8,
                        fontFamily: "NotoSansKR-Regular",
                        fontSize: 10,
                        color: "#616161",
                        textAlign: "center"
                    }}>
                        {loggedInUserEmail}
                    </Text>
                    <UserProfileCollapsedImg style={{
                        transform: userProfileShowYn ? "rotate(180deg)" : ""
                    }}/>
                </div>
            </div>
            {
                userProfileShowYn
                ? <div ref={profileLayout}><HeaderUserProfile setLoading={props.setLoading} detectClictEventCb={detectClictEvent}/></div>
                : null
            }
            {
                menuExpandShowYn && <div ref={sitemapLayout}><SiteMap detectClictEventCb={detectClictEvent} clickMenuLinkCb={clickMenuLink}/></div>
            }
            {/* {
                menuExpandShowYn ? <HeaderMenu  detectClictEventCb={detectClictEvent} clickMenuLinkCb={clickMenuLink}/> : null
            } */}
        </View>
    );
}

const className = {
    menuTotalViewImg: {
        cursor: "pointer"
    },
}